import { useMemo, useRef } from 'react';
import { makeSingleFlight } from '../utils/singleFlight';

/**
 * Functional-component wrapper around makeSingleFlight (see utils/singleFlight.js).
 *
 * The guarded function is created once so its in-flight flag persists across renders,
 * but it always calls the latest `fn` via a ref — so the handler closes over current
 * props/state rather than the values from first render.
 */
const useSingleFlight = (fn) => {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  return useMemo(() => makeSingleFlight((...args) => fnRef.current(...args)), []);
};

export default useSingleFlight;
